import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';

import './AutocompleteField.less';

export function AutocompleteField({ wrapperClassName, renderMenu, ...props }) {
  return (
    <Autocomplete
      renderMenu={renderMenu}
      wrapperProps={{ className: wrapperClassName ? `autocomplete_field ${wrapperClassName}` : 'autocomplete_field' }}
      // inputProps are passed to the <input> element in react-autocomplete
      {...props}
    />
  );
}

AutocompleteField.propTypes = {
  wrapperClassName: PropTypes.string,
  renderMenu: PropTypes.func,
};

AutocompleteField.defaultProps = {
  wrapperClassName: '',
  renderMenu: (menuItems) => <div className="menu">{menuItems}</div>,
};

export default AutocompleteField;
